import { FC, useCallback, useState } from 'react';
import { ShoppingCart as ShoppingCartIcon } from 'phosphor-react';
import { Addon, ShopContent } from '../../../types/cms_shared_types';
import { ShoppingCartModal } from './ShoppingCartModal';
import { AddonListActions, Product, ProductListActions } from '../../../types/webshop';

interface ShoppingCartProps {
  selectedCategoryKey?: string;
  selectedSubcategoryKey?: string;
  price: string;
  vatPrice: string;
  selectedProducts?: Product[];
  selectedProductsActions?: ProductListActions;
  selectedAddons: Addon[];
  selectedAddonsActions: AddonListActions;
  disable?: boolean;
  cmsShopContent: ShopContent;
}

export const ShoppingCart: FC<ShoppingCartProps> = ({
  selectedCategoryKey,
  selectedSubcategoryKey,
  price,
  vatPrice,
  selectedProducts,
  selectedProductsActions,
  selectedAddons,
  selectedAddonsActions,
  disable,
  cmsShopContent,
}) => {
  const [showShoppingCartModal, setShowShoppingCartModal] = useState(false);

  const getHoverStyling = () => {
    if (!disable) {
      return 'hover:bg-black hover:bg-opacity-5 cursor-pointer';
    }
    return '';
  };

  const getProductCount = useCallback((): string => {
    const productCount = selectedProducts?.length ?? 0;
    const addonCount = selectedAddons?.length ?? 0;
    const totalCount = productCount + addonCount;

    if (totalCount > 9) {
      return '9+';
    }

    return totalCount.toString();
  }, [selectedAddons?.length, selectedProducts?.length]);

  return (
    <>
      <div
        onClick={() => !disable && setShowShoppingCartModal(true)}
        className={`w-fit flex flex-row items-center px-3 py-2 sm:px-6 sm:py-2 bg-input-gray sm:bg-transparent rounded-lg sm:rounded-[100px] border border-input-border sm:border-none ${
          disable ? 'hidden' : ''
        } ${getHoverStyling()}`}
      >
        <div className="relative inline-block">
          <ShoppingCartIcon size={32} className="text-sami-green" />
          <div className="absolute -right-1 -top-1">
            <div className="flex items-center justify-center w-5 h-5 text-xs font-bold text-white border border-white rounded-full bg-sami-green">
              {getProductCount()}
            </div>
          </div>
        </div>

        <div className="hidden ml-3 text-base font-bold truncate sm:block text-sami-green">
          {price} {cmsShopContent.priceWithMonthFormat}
        </div>
      </div>

      {selectedProducts && selectedProductsActions && selectedAddons && selectedAddonsActions ? (
        <ShoppingCartModal
          showShoppingCartModal={showShoppingCartModal}
          setShowShoppingCartModal={setShowShoppingCartModal}
          selectedCategoryKey={selectedCategoryKey}
          selectedSubcategoryKey={selectedSubcategoryKey}
          price={price}
          vatPrice={vatPrice}
          selectedProducts={selectedProducts}
          selectedProductsActions={selectedProductsActions}
          selectedAddons={selectedAddons}
          selectedAddonsActions={selectedAddonsActions}
          cmsShopContent={cmsShopContent}
        />
      ) : (
        <></>
      )}
    </>
  );
};
